import { render, staticRenderFns } from "./ManageDrawer.vue?vue&type=template&id=2c89d28c&scoped=true&"
import script from "./ManageDrawer.vue?vue&type=script&lang=js&"
export * from "./ManageDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c89d28c",
  null
  
)

export default component.exports